import {
  PROVIDER_DETAILS_SUCCESS,
  PROVIDER_DETAILS_FAILURE,
} from '../actions/types';

const initialState = null;

export default function providerDetailsReducer(
  state = initialState,
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case PROVIDER_DETAILS_SUCCESS:
      return payload;
    case PROVIDER_DETAILS_FAILURE:
      return false;

    default:
      return state;
  }
}
